// extracted by mini-css-extract-plugin
export var bold = "_ye-0";